module.exports = __webpack_public_path__ + "img/p6-desc.060d6975.jpg";